import React from "react";
import { AwardIcon, GaugeIcon, TruckIcon, HeadsetIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { SectionHeading } from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
const icons = [AwardIcon, GaugeIcon, TruckIcon, HeadsetIcon];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-232" data-mp="72q824blbpvo">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-233" data-mp="74b1trq2z4sh">
        <SectionHeading eyebrow={t.why.eyebrow} title={t.why.title} data-id="element-234" data-mp="233u1snxu5lt" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-235" data-mp="25zp998eig6k">
          {t.why.items.map((item, i) => {
          const Icon = icons[i % icons.length];
          return <Reveal key={item.title} delay={i * 0.06} data-id="element-236" data-mp="3od7so5zrgczy" data-mpi={i}>
                <div className="group h-full rounded-sm border border-slate-200 bg-white p-7 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-orange hover:shadow-xl" data-id="element-237" data-mp="1rha187rw1yzs">
                  <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-navy transition-colors duration-300 group-hover:bg-orange group-hover:text-white" data-id="element-238" data-mp="2uzlsjqupryc0">
                    <Icon size={30} data-id="element-239" data-mp="2l3itwuz2mhtt" />
                  </span>
                  <h3 className="mt-5 font-heading font-bold uppercase text-navy text-xl" data-id="element-240" data-mp="2q1al1mrw5zwy">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed" data-id="element-241" data-mp="3dsg388lb14af">{item.desc}</p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}